export const ER_PRECAUTIONS_SCRIPT =
  'Before we finish, I want to make sure you know: if you ever feel chest ' +
  'pain, trouble breathing, sudden weakness, or like something is seriously ' +
  'wrong, please call 911 or go to your nearest emergency room right away. ' +
  "Don't wait to call us first. And if you develop any of the symptoms we " +
  "just talked about, or you're feeling unwell or concerned for any reason, " +
  'please call us back right away or seek emergency care.';

export const CONSENT_ATTESTATION_SCRIPT =
  'Can you attest that you are authorized to receive information regarding ' +
  "the patient's care and participation in Tellihealth services and " +
  "communicate with us on the patient's behalf?";
